export const eOpenDates = {
    LAST_30_DAYS: 'Last 30 days',
    LAST_3_MONTHS: 'Last 3 months',
    LAST_6_MONTHS: 'Last 6 months',
    CUSTOM: 'Custom'
};
